import { Locale } from 'date-fns';
import { type PollTimeSpanTranslations, TimeSpans } from '../Poll.model';

const formatTimeSpanText = (
	number: number,
	singularTimeSpan: string,
	pluralTimeSpan: string
) => `${number} ${number === 1 ? singularTimeSpan : pluralTimeSpan}`;

export const createPollDateLocale: (
	translations: PollTimeSpanTranslations
) => Locale = (translations) => ({
	formatDistance: (timeSpan: string, number: number) => {
		const format = (
			singularTimeSpan: keyof PollTimeSpanTranslations,
			numberOverwrite?: number
		) => {
			const timeSpans: [string, string] = [
				translations[singularTimeSpan],
				translations[
					(singularTimeSpan + 's') as keyof PollTimeSpanTranslations
				],
			];

			return formatTimeSpanText(numberOverwrite ?? number, ...timeSpans);
		};

		switch (timeSpan) {
			case TimeSpans.Days:
				if (number < 8) {
					return format('day');
				}
				return format('week', Math.floor(number / 7));
			case TimeSpans.Hours:
				return format('hour');
			case TimeSpans.Minutes:
				return format('minute');
			case TimeSpans.Months:
				return format('month');
			case TimeSpans.Years:
				return format('year');
			default:
				break;
		}
	},
});
